module.exports = __webpack_public_path__ + "img/arrow-down.b5d936d7.svg";